import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import "@styles/pages/Inquiry/Inquiry.scss";
import RegistrationInquiry from "@pages/Inquiry/step1/RegistrationInquiry";
import EnrollmentList from "@pages/Inquiry/step2/EnrollmentList";
import WorkshopChangePage from "@pages/Inquiry/step3/WorkshopChangePage";
import { Box } from "@mui/material";
import { resetFormStep } from "@store/ui/formStepSlice";

const Inquiry = () => {
  const dispatch = useDispatch();
  const currentStep = useSelector((state) => state.formStep.inquiry);

  useEffect(() => {
    dispatch(resetFormStep({ formKey: "inquiry" }));
  }, []);

  return (
    <Box className="inquiry-container">
      <Box className="inquiry-detail-container">
        {currentStep === 0 && <RegistrationInquiry />}
        {currentStep === 1 && <EnrollmentList />}
        {currentStep === 2 && <WorkshopChangePage />}
      </Box>
    </Box>
  );
};

export default Inquiry;
